module.exports = "<p>\r\n  donation-recepits works!\r\n</p>\r\n"